$(document).on('change', '.blog-categories-select select', function() {
  window.location.href = $(this).val();
});

$(document).on('click', '.blog-sidebar .search__button', function(e) {
  let cont = $(this).closest('.blog-sidebar');
  if($(window).width() < 768 && !cont.hasClass('active')) {
    e.preventDefault();
    cont.addClass('active');
    cont.parent().addClass('sidebar-active');
  }
});

function setUpBlogLanding() {

  if($('[data-articles]').length < 1) return;
  let articleData = JSON.parse($('[data-articles]').attr('data-articles'));
  let perPage = parseInt($('[data-articles]').attr('data-per-page'));
  if($(window).width() < 768) perPage = 8;
  let blogIds = $('[data-articles]').attr('data-blog-ids');
  let targetContainer = $('.blog-listing.regular-blog-list');
  let page = 1;
  let newArticles = [];
  let categories = {};

  articleData = sortyArticlesByDate(articleData);

  let tpl = $('.article-card-tpl .grid__item');
  let _clone = tpl.clone();
  tpl.remove();

  // Get page
  var url_string = window.location.href;
  var url = new URL(url_string);
  var p = url.searchParams.get("p");
  if(typeof p != "undefined" && p != null && p.length > 0) page = parseInt(p);

  // Filter articles array to show only the current page articles
  let offset = page === 1 ? 0 : perPage * (page - 1);
  let end = offset + perPage;
  let articlesToShow = articleData.slice(offset, end);

  blogIds = blogIds.split(',');
  blogIds.forEach(function(blog) {
    let data = blog.split('--');
    let id = data[0];
    let handle = data[1];
    categories[id] = handle;
  });

  // Update template data with articles data and push them to the container el
  articlesToShow.forEach(function(article) {
    let clone = _clone.clone();

    let imgContainerT = clone.find('.article-card__image');
    let imgT = imgContainerT.find('img');
    imgT.removeAttr('srcset');
    if(typeof article.image != "undefined") {
      imgT.attr('src', article.image.src);
    }

    let aT = clone.find('a');
    let URL = 'https://' + window.location.host + '/blogs/' + categories[article.blog_id] + '/' + article.handle;
    aT.attr('href', URL);

    let timestamp = (new Date(article.published_at)).getTime();
    let cardT = clone.find('.card.article-card');
    cardT.attr('data-date', timestamp);

    let titleT = clone.find('.card__heading a');
    titleT.html(article.title);

    let excerptT = clone.find('.article-card__excerpt');
    excerptT.html(article.summary_html);

    let categoriesT = clone.find('.card__categories');
    categoriesT.html('');
    categoriesT.append('<a class="card__badge" href="https://' + window.location.host + '/blogs/' + categories[article.blog_id]+'">'+categories[article.blog_id]+'</a>');

    //rama this is for tags
    let article_tags = clone.find('.tags');
    article_tags.html('');

    let alltags = article.tags.split(',');
    
    for(var i = 0; i < alltags.length; i++)
    {
      if(article.tags.length)
      {
        if(!alltags[i].includes("hide-") && !alltags[i].includes("author:"))
        {
           article_tags.append('<div class="tag">'+alltags[i]+'</div>');  
        }
      }
    }//loop closed
    
    newArticles.push(clone);
    targetContainer.append(clone);
  });

}

function sortyArticlesByDate(articles) {
  articles.sort(function(a,b){
    return new Date(b.created_at) - new Date(a.created_at);
  });
  return articles;
}

function setUpBlogLandingPagination() {
  let currentPage = 1;

  if($('[data-articles]').length < 1) return;
  let articleData = JSON.parse($('[data-articles]').attr('data-articles'));
  let perPage = parseInt($('[data-articles]').attr('data-per-page'));
  let container = $('.pagination-container');
  let target = container.find('.pagination');
  let prev = container.find('.prev');
  let next = container.find('.next');

  // Get current page
  var url_string = window.location.href;
  var url = new URL(url_string);
  var p = url.searchParams.get("p");
  if(typeof p != "undefined" && p != null && p.length > 0) currentPage = parseInt(p);

  // Get all pages
  let allPages = Math.ceil(articleData.length / perPage);

  let pages = [];
  if(currentPage > 0 && currentPage < 4) {
    pages = [1,2,3,4,'...',allPages];
  }
  else if(currentPage > 3 && currentPage < (allPages - 3)) {
    pages = [
      '...',
      currentPage - 2,
      currentPage - 1,
      currentPage,
      currentPage + 1,
      currentPage + 2,
      '...',
      allPages];
  }
  else if(currentPage >= (allPages - 3)) {
    pages = [
      '...',
      allPages - 3,
      allPages - 2,
      allPages - 1,
      allPages];
  }

  let lastPage = 0;
  for(let i=0; i < allPages; i++) {
    if(typeof pages[i] != "undefined") {
      let pageURL = new URL(url_string);
      if(isNaN(pages[i])) {
        if(i < 1) pageURL.searchParams.set('p', currentPage - 3)
        else pageURL.searchParams.set('p', lastPage + 1);
      }
      else {
        lastPage = pages[i];
        pageURL.searchParams.set('p', pages[i]);
      }
      let current = pages[i] === currentPage ? 'current' : '';
      target.append('<a href="'+pageURL+'" class="'+current+'">'+pages[i]+'</a>');
    }
  }

  let prevURL = new URL(url_string);
  let nextURL = new URL(url_string);
  prevURL.searchParams.set('p', currentPage - 1)
  nextURL.searchParams.set('p', currentPage + 1)
  prev.attr('href', prevURL);
  next.attr('href', nextURL);

  if(currentPage === 1) {
    prev.addClass('hide');
  }
  else if(currentPage === allPages) {
    next.addClass('hide');
  }
}

$(function() {
  setUpBlogLanding();
  setUpBlogLandingPagination();
});